import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const PLACEHOLDER_VALUES = new Set([
  "unknown",
  "unknown venue",
  "unknown region",
  "unknown city",
  "unknown country",
  "n/a",
  "none",
  "-",
])

export function normalizeUnknownValue(value?: string | null): string | null {
  if (value === undefined || value === null) return null
  const trimmed = String(value).trim()
  if (!trimmed) return null
  const lowered = trimmed.toLowerCase()
  if (PLACEHOLDER_VALUES.has(lowered)) {
    return null
  }
  if (lowered.startsWith("unknown ")) {
    return null
  }
  return trimmed
}
